<template>
  <v-layout row wrap align-start justify-center pb-5>
    <v-flex xs12>
      <v-layout row wrap align-start justify-center>
        <v-flex xs12 md6 mt-4>
          <h1>{{$lang.header.rateUs}}:</h1>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-start justify-center pb-4>
        <v-flex xs12 md6 id="commentField">
          <v-text-field
              :label="$lang.labels.comment"
              v-model="comment"
              :hint="$lang.header.rateHint"
              persistent-hint
              required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-start justify-center>
        <v-flex xs12 md6 class="text-xs-center">
          <template v-for="star in 5">
            <v-icon :key="star" class="cursorPointer"
                    :size="$vuetify.breakpoint.smAndDown ? '72' : '86'"
                    :color="gold[star] ? 'primary' : ''"
                    @mouseenter="starGold(star)" @click="goldSet = star; starGold(star)">star
            </v-icon>
          </template>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-start justify-center pt-3>
        <v-flex xs12 md6>
          <v-btn style="margin: 0 !important" color="primary" :disabled="!comment || !goldSet" @click="rate()">{{$lang.actions.submit}}</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md8 mb-4 v-if="success">
      <v-alert
          color="success"
          class="success"
          value="true"
          v-if="success">{{ success }}
      </v-alert>
    </v-flex>
    <v-flex xs12 md8 mb-4 v-if="err">
      <v-alert
          color="error"
          class="err"
          icon="warning"
          value="true"
          v-if="err">{{ err }}
      </v-alert>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AdminPanel',
  data() {
    return {
      gold: [true, true, false, false, false, false],
      goldSet: null,
      err: '',
      success: '',
      comment: '',
      loading: false,
      loginProcessStarted: false,
    };
  },
  computed: {
    ...mapGetters({
      company: 'company',
      companyActive: 'companyActive',
    }),
  },
  methods: {
    starGold(index) {
      this.gold = this.gold.map((x, i) => {
        let item = x;
        item = this.goldSet ? i <= this.goldSet : i <= index;
        return item;
      });
    },
    rate() {
      if (!this.comment) {
        this.startErrorAnimation('commentField');
        return;
      }
      this.err = '';
      this.success = '';
      this.$webHelper.post(`rating/${this.$route.params.hash}`, {
        stars: this.goldSet,
        comment: this.comment,
      })
        .then((res) => {
          if (res.body && res.status === 200) {
            this.$router.push({ name: 'webShop', query: { rateSuccessful: true } });
          } else {
            this.err = res.body.statusText;
          }
        })
        .catch((err) => {
          this.err = err;
        });
    },
    checkRate() {
      this.$webHelper.get(`rating/${this.$route.params.hash}`)
        .then((res) => {
          if (res.status !== 200) {
            this.err = res.body.statusText;
          }
        })
        .catch((err) => {
          this.err = err;
          setTimeout(() => {
            this.err = '';
          }, 6000);
        });
    },
    startErrorAnimation(elementId) {
      const el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(() => {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
  },
  created() {
    this.checkRate();
  },
};
</script>

<style scoped lang="scss">
.cursorPointer {
  cursor: pointer;
}

.ahashakeheartache {
  -webkit-animation: kf_shake 0.4s 1 linear;
  -moz-animation: kf_shake 0.4s 1 linear;
  -o-animation: kf_shake 0.4s 1 linear;
}

@-webkit-keyframes kf_shake {
  0% {
    -webkit-transform: translate(30px);
  }
  20% {
    -webkit-transform: translate(-30px);
  }
  40% {
    -webkit-transform: translate(15px);
  }
  60% {
    -webkit-transform: translate(-15px);
  }
  80% {
    -webkit-transform: translate(8px);
  }
  100% {
    -webkit-transform: translate(0px);
  }
}

@-moz-keyframes kf_shake {
  0% {
    -moz-transform: translate(30px);
  }
  20% {
    -moz-transform: translate(-30px);
  }
  40% {
    -moz-transform: translate(15px);
  }
  60% {
    -moz-transform: translate(-15px);
  }
  80% {
    -moz-transform: translate(8px);
  }
  100% {
    -moz-transform: translate(0px);
  }
}

@-o-keyframes kf_shake {
  0% {
    -o-transform: translate(30px);
  }
  20% {
    -o-transform: translate(-30px);
  }
  40% {
    -o-transform: translate(15px);
  }
  60% {
    -o-transform: translate(-15px);
  }
  80% {
    -o-transform: translate(8px);
  }
  100% {
    -o-origin-transform: translate(0px);
  }
}

.err {
  border-color: #d84315 !important;
}

.success {
  border-color: #d84315 !important;
}

</style>


// WEBPACK FOOTER //
// src/components/Rate.vue